import React from 'react';

export const Copy: React.FC = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect
      x="4.08325"
      y="4.08325"
      width="8.16667"
      height="8.16667"
      rx="1.16667"
      stroke="currentColor"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.91667 8.75C9.91667 9.39433 9.39433 9.91667 8.75 9.91667"
      stroke="currentColor"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M9.91667 5.83325V6.99992"
      stroke="currentColor"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M6.99992 9.91667H5.83325"
      stroke="currentColor"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M4.08333 9.91667H2.91667C2.27233 9.91667 1.75 9.39433 1.75 8.75V2.91667C1.75 2.27233 2.27233 1.75 2.91667 1.75H8.75C9.39433 1.75 9.91667 2.27233 9.91667 2.91667V4.08333"
      stroke="currentColor"
      strokeWidth="0.75"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);
